import { useCart } from "context/CartContex";
import { useState } from 'react';
import { useForm } from "react-hook-form";
import * as S from './styles';
//components
import CardOrder from '../Cards';
import Promocao from "../Promocao";
import SearchField from '../SerarchField';
//hooks
import { useMultipleModal } from '../../../../hooks/useMultipleModal';
export type Inputs = {
    number_ata: string;
    customer_id: number,
    user_id: number,
    payment_method_id: number,
    items: [],
    date_sale: string,
}

export default function SelectProduct() {
    const {
        state,
        removeFromCart,
        addPromotionToProduct,
        addPaymentsToProduct
    } = useCart();
    const {
        formState: { errors },
    } = useForm<Inputs>();
    //hooks
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();

    // Estado para armazenar o ID e TYPE do produto selecionado
    const [promoProduct, setPromoProduct] = useState({
        id: 0,
        type: '',
        value: '',
        quantity: 1
    })

    //Acões para o CardOrder
    const handleButtonCard = (type: string, product: any) => {
        //Adcionar Proomoção
        if (type === 'promo') {
            setPromoProduct({
                id: product.id,
                type: product.type,
                value: product.price || 0,
                quantity: product.quantity || 1
            })
            toggleModalVisibility("details-payment");
            //remover item
        } else if (type === 'delete') {
            removeFromCart(product.id.toString());
            //Atualizar Promoção
        }
    }

    //Função para aplicar promoção
    const handleAplyPromotions = (product: any) => {
        const promotions = product.promotions || null;
        const payments = product.payments || [];

        addPromotionToProduct(promoProduct.id.toString(), promotions);
        addPaymentsToProduct(promoProduct.id.toString(), payments);
    }

    return (
        <S.Main>
            <S.Form>
                <SearchField
                    typeField='sale'
                    placeholder='Buscar o produto'
                    htmlFor='produto'
                    url='/sale-search-stock'
                    onSelect={(productSelecionado) => {
                        console.log("Produto escolhido");
                    }}
                />

                <S.ContentForms>
                    <CardOrder
                        selectedProducts={state.items || []}
                        onDeleteProduct={(product: any) => handleButtonCard('delete', product)}
                        onEditProduct={(product: any) => handleButtonCard('promo', product)}
                    />
                </S.ContentForms>
            </S.Form>

            <Promocao
                type={promoProduct.type || ''}
                id={promoProduct.id || null}
                isOpenModals={isOpenModal("details-payment")}
                setModalClose={() => toggleModalVisibility("details-payment")}
                dataPayment={(novoProduto: any) => {
                    handleAplyPromotions(novoProduto);
                }}
            />
        </S.Main>
    )
}